<template>
<div>
  <div class="d-flex" id="wrapper">
    <SideBar />
    <div id="page-content-wrapper">
      <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
        <div>
          <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
          </button>

          <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
          </button>
        </div>
        <div class="d-flex">
          <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
          <p class="text-primary mb-0 hover-cursor">&nbsp; Assembly</p>
        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ admin }}
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 grid-margin stretch-card card-div">
            <div class="container">
              <h5 class="card-title mt-3 mb-5">Update Info Unit</h5>
            </div>
            <div class="container">
              <div class="row align-items-start my-2">
                <div class="col-lg-2 mt-2">
                  SC/SN
                </div>
                <div class="col-lg-10 pl-0">
                  <input type="text" v-model="snsc" class="form-control" v-on:keyup.enter="doSearchSn">
                  <div class="container my-2" v-if="snSelected.length > 0">
                    <div class="row align-items-center justify-content-between" v-for="(item,i) in snSelected" :key="`selectedSn-${i}`">
                      <div class="col-lg-11 py-2 mt-1 component-border rounded">
                        <div>{{item.itemGroup}} - {{item.itemName}}</div>
                        <div>{{item.serialNumber}}/{{item.stockCode}} ({{item.status}})</div>
                      </div>
                      <button class="btn btn-danger py-1 px-3 mr-3 font-weight-bold" @click="deleteSelectedSn(item)">-</button>
                    </div>
                  </div>
                  <div class="mt-4">BOM</div>
                  <button class="btn btn-primary w-100 my-2" @click="openModalBom" :disabled="snSelected.length == 0">Pilih BOM</button>
                  <div class="w-100 p-2 component-border rounded mb-2" v-if="bom.bomName">
                    <div>{{bom.bomName}}</div>
                    <div v-for="(item,i) in bom.itemBom" :key="`bom-${i}`">
                      <div v-for="(val, j) in item.itemQty" :key="`itemBom${i}-${j}`">
                        {{item.itemName}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-right my-5">
                <button class="btn btn-primary py-2 px-3" @click="saveUpdateInfo" :disabled="snSelected.length == 0 || bom == ''" v-if="!loadingBtnSave">Simpan</button>
                <button type="button" class="btn btn-primary" disabled v-else><img src="~@/assets/images/2.gif" style="height: 24px;">Loading</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal select bom -->
      <div class="modal fade" id="modalSelectBom" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <!-- Modal Content -->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Pilih BOM</h4>
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body py-3">
              <div class="col-lg-12 component-border bom-selection rounded my-2" v-for="(itemb,index) in selectBom" :key="`itemb-${index}`" @click="setBom(itemb)">
                <div>
                  <div>{{itemb.bomName}}</div>
                  <div v-for="(comp,i) in itemb.itemBom" :key="`comp-${i}`">
                    <div v-for="(qty,j) in comp.itemQty" :key="`copm${i}-${j}`">
                      {{comp.itemName}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-12 py-3"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal Notif -->
      <div class="modal fade" id="modalSnAssembly" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <!-- Modal Content -->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h5 class="modal-title">{{notifTitle}}</h5>
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body py-3">
              <div class="p-3">
                <div>Body - Lenovo Thinkpad T440p i5</div>
                <div>RAM DDR3 4GB</div>
                <div>RAM DDR3 4GB</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import swal from 'sweetalert';
import Multiselect from 'vue-multiselect';
import SideBar from '../SideBar.vue';
export default {
  name: 'UpdateInfoPage',
  components: {
    Multiselect,
    SideBar
  },
  data() {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      permission: [],
      admin: '',
      adminId: '',
      warehouse: '',
      perakitan: '',
      itemChoose: '',
      type: '',
      snsc: '',
      snSelected: [],
      snItemName: '',
      bom: '',
      part: '',
      notifTitle: '',
      notifType: '',
      selectBom: [],
      loadingBtnSave: false
    }
  },
  methods: {
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    openModalBom() {
      this.getBom()
    },
    toPage(e) {
      this.$router.push(e)
    },
    setBom(item) {
      this.bom = item
      $("#modalSelectBom").modal("hide")
    },
    doSearchSn() {
      if(this.snsc.length > 0) {
        this.$http.post(process.env.ASSEMBLY_SEARCH_SN_UPDATE, {
            scsn: this.snsc.replace(this.spaceRegex, ' '),
            itemName: this.snItemName.replace(this.spaceRegex, ' ')
          }, {
            headers: {
              'Asani-Token': localStorage.getItem('jwt')
            }
          })
          .then(res => {
            if (res.data.status == 200) {
              var found = false
              if (this.snSelected.length == 0) {
                this.notifTitle = res.data.content.itemGroup + ' - ' + res.data.content.itemName
                this.snItemName = res.data.content.itemName
                this.snSelected.push(res.data.content)
                // $("#modalSnAssembly").modal("show")
              } else {
                this.snSelected.forEach(el => {
                  if (el.serialNumber == res.data.content.serialNumber) {
                    found = true
                  } else {
                    found = false
                  }
                })
                if (found == true) {
                  swal('Error', 'SN sudah dipilih.', 'error')
                } else if (found == false) {
                  this.snSelected.push(res.data.content)
                  this.notifTitle = res.data.content.itemGroup + ' - ' + res.data.content.itemName
                  this.snItemName = res.data.content.itemName
                  // $("#modalSnAssembly").modal("show")
  
                }
              }
            } else {
              swal('Error', res.data.message, 'error')
            }
          })
          .catch(error => {
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          })
      } else {
        swal('Error', 'Masukkan SN/SC', 'error')
      }
    },
    deleteSelectedSn(item) {
      let newSelected = []
      this.snSelected.forEach(el => {
        if (el !== item) {
          newSelected.push(el)
        }
      })
      this.snSelected = newSelected
      if(this.snSelected.length == 0) {
        this.resetData()
      }
    },
    getBom() {
      this.$http.get(process.env.GET_CATALOG_BOM + this.snSelected[0].itemCode, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(res => {
          console.log(res)
          if (res.data.status == 200) {
            this.selectBom = res.data.content
            $("#modalSelectBom").modal("show")
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    saveUpdateInfo() {
      this.loadingBtnSave = true
      let snScList = []
      this.snSelected.forEach(el => {
        snScList.push(el.id)
      })
      this.$http.post(process.env.ASSEMBLY_SAVE_UPDATE_INFO, {
          snScList,
          bomSelected: this.bom.bomName ? this.bom.bomName.replace(this.spaceRegex, ' ') : this.bom.bomName
        }, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(res => {
          if (res.data.status == 200) {
            swal('Success', 'Berhasil update Info Unit.', 'success')
            this.loadingBtnSave = false
            this.resetData()
          } else {
            swal('Error', res.data.message, 'error')
            this.loadingBtnSave = false
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    resetData() {
      this.bom = ''
      this.snSelected = []
      this.selectBom = []
      this.snsc = ''
      this.snItemName = ''
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin() {
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    cekPermission() {
      this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == '10') {
          this.viewEmployee = true
        }
      }
      if (this.viewEmployee == false) {
        this.$router.push('/')
      }
    },
  },
  created() {
    this.admin = localStorage.getItem('admin_name')
    this.adminId = localStorage.getItem('admin_id')
    this.cekLogin()
    this.cekPermission()
  }
}
</script>

<style scoped>
.component-border {
  border: 1px solid rgb(206, 212, 218);
  background-color: rgb(233, 236, 239);
}

.bom-selection {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Assembly/UpdateInfo.vue